// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/certifications-report/components/certifications-report-header/certifications-report-header.less
// module id = 3934
// module chunks = 0